module.exports = __webpack_public_path__ + "static/img/o_consultation1.9f199dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/o_consultation1.jpg
// module id = 97
// module chunks = 1